<phms-case-context-record-grid
  [appTerminologyIdentity]="facilityUsage.heading"
  [heading]="facilityText.heading()"
  [records]="records"
  [state]="state"
  [stateCopy]="{
    loadingText: facilityText.loading(),
    emptyText: facilityText.empty(),
    errorText: facilityText.unavailable()
  }"
  itemLabelSingular="conduct record"
  itemLabelPlural="conduct records"
  [columnDefs]="columnDefs"
></phms-case-context-record-grid>
